import { proxy as palette } from "../color.palette";
import { proxy as functional } from '../color.functional';

const color = {...palette, ...functional};

export const monoButton = {
  background_hover: color.mono_100
}
